import React, { useState,useEffect } from "react";
import ConfigFileGenerator from "./GenerateConfigFile";
import ConfigFile from "./ParsePanelData";
import { toast, ToastContainer } from 'react-toastify';
import Axios from "axios";
import { useRef} from "react";
import { useParams } from "react-router-dom";
const CloudProConfigFile = ({ onClose, onImported, selectedProject, setSelectedProject, setPanelCache, setSelectedPanel, setApiPanels }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState("");
  const [uploadError, setUploadError] = useState("");
  const fileInputRef = useRef(null);
  const { mdId } = useParams();
      const siId = localStorage.getItem("siId");
       const [configFileData, setConfigFileData] = useState(null);
       const [selectedPanelName, setSelectedPanelName] = useState("");

useEffect(() => {
  try {
    const storedPanelName = sessionStorage.getItem("selectedPanel");
    if (storedPanelName) {
      setSelectedPanelName(JSON.parse(storedPanelName));
    }
  } catch (e) {
    console.error("Failed to parse selectedPanel from sessionStorage:", e);
  }
}, []);

 const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  setSelectedFile(file);
  setUploadError("");
  setUploadSuccess("");
};
const getProjectId = () =>
  JSON.parse(sessionStorage.getItem("selectedProject") || "null")?.project_id;

const getFileIds = () => {
  try { return JSON.parse(sessionStorage.getItem("causeEffectFileIds") || "{}"); }
  catch { return {}; }
};
const saveFileId = (key, id) => {
  const ids = getFileIds();
  ids[key] = id;
  sessionStorage.setItem("causeEffectFileIds", JSON.stringify(ids));
};
const clearFileId = (key) => {
  const ids = getFileIds();
  delete ids[key];
  sessionStorage.setItem("causeEffectFileIds", JSON.stringify(ids));
};

const workflowPost = async (endpoint, body) => {
  const { data } = await Axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/api/cause-effect-workflow${endpoint}`,
    body
  );
  return data;
};

const parseCfg = (fileObj) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const cfg = new ConfigFile(sessionStorage.getItem("panelVersion1"));
        cfg.readFile(e.target.result);
        resolve(cfg.VT5000_CONFIG);
      } catch (err) { reject(err); }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(fileObj);
  });



const handleUpload = async () => {
  if (!selectedFile) {
    setUploadError("⚠️ Please select a file before uploading.");
    return;
  }

  try {
    setUploading(true);
    setUploadError("");
    setUploadSuccess("");

    const projectId = getProjectId();
    if (!projectId) throw new Error("Project ID not found.");

    const parsedConfig = await parseCfg(selectedFile);
    const fileKey = `${projectId}::${selectedFile.name}`;

  
    let revision = Number(sessionStorage.getItem("causeEffectRevision")) || 1;
    let fileId = getFileIds()[fileKey];

    const buildBody = () => ({
      email: localStorage.getItem("userEmail"),
      projectId,
      expectedRevision: revision,
      files: [{
        filename: selectedFile.name,
        content: parsedConfig,
        ...(fileId ? { fileId } : {}),
      }],
    });

    let res;
    try {
      res = await workflowPost("/configs/import", buildBody());
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data;

  
      if (data?.code === "FILE_NOT_FOUND" && fileId) {
        clearFileId(fileKey);
        fileId = undefined;
        res = await workflowPost("/configs/import", buildBody());

    
      } else if (status === 409) {
        const cur = data?.currentRevision ?? data?.details?.currentRevision;
        if (!cur) throw err;
        revision = Number(cur);
        sessionStorage.setItem("causeEffectRevision", String(cur));
        res = await workflowPost("/configs/import", buildBody());

      } else {
        throw err;
      }
    }

    if (!res?.revision) throw new Error("Import succeeded but no revision was returned.");
    sessionStorage.setItem("causeEffectRevision", String(res.revision));

    const imported = res.files?.find((f) => f.filename === selectedFile.name);
    if (imported?.fileId) saveFileId(fileKey, imported.fileId);

setUploadSuccess(`Config imported successfully. Revision: ${res.revision}`);

    
    await onImported?.(imported?.fileId);
    onClose?.();
  } catch (error) {
    console.error("Cause & Effect import failed:", error?.response?.data || error);
    setUploadError(
      error?.response?.data?.msg ||
      error?.response?.data?.message ||
      error?.response?.data?.error?.message ||
      error?.message ||
      "Failed to import config."
    );
  } finally {
    setUploading(false);
  }
};
  return (
    <div className="popup">
      <div className="popup-content">
        <h6>Import Config File</h6>

        
        <input
          type="file"
          accept=".cfg"
          onChange={handleFileChange}
        />

        {selectedFile && (
          <p style={{ marginTop: "10px" }}>
            Selected File: <b>{selectedFile.name}</b>
          </p>
        )}

      
        {uploading && (
          <p style={{ color: "blue" }}>
            Uploading file...
          </p>
        )}


        {uploadSuccess && (
          <p style={{ color: "green" }}>
            {uploadSuccess}
          </p>
        )}


        {uploadError && (
          <p style={{ color: "red" }}>
            {uploadError}
          </p>
        )}

        <div style={{ marginTop: "15px" }}>
        <button
  disabled={uploading}
  style={{ background: "#007bff", borderRadius: "5px", color: "white",
           cursor: uploading ? "not-allowed" : "pointer", opacity: uploading ? 0.6 : 1 }}
  onClick={handleUpload}
>
  {uploading ? "Uploading..." : "Upload File"}
</button>

          <button style={{background: "#f8f9fa", border: "1px solid #6c757d",borderRadius: "5px",color: "black",marginLeft: "10px",cursor:"pointer"}}
            onClick={onClose}
            
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloudProConfigFile;